var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfPrevOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.159 4.2203C10.3658 4.09124 10.5688 4.08291 10.7679 4.1953C10.9671 4.3077 11.0667 4.48398 11.0667 4.72415V11.3664C11.0667 11.5954 10.9671 11.7662 10.7679 11.8785C10.5688 11.9909 10.3658 11.9826 10.159 11.8535L4.93978 8.5177C4.75517 8.39974 4.66287 8.23949 4.66287 8.03693C4.66287 7.83437 4.75517 7.67411 4.93978 7.55617L10.159 4.2203Z",
    fill: "#374151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfPrevOne);
export default __webpack_public_path__ + "static/media/pdf-prev-one.d1a8caaf72031b1edd04374386821e5f.svg";
export { ForwardRef as ReactComponent };